import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Profile from '../user-admin/user-details/Profile';
import ThreeWayCallDetailsModal from '../user-admin/user-details/three-way/threeWayCallDetailsModal';

import { getAgent } from '../../actions/agent';

function ProfilePage() {
  const dispatch = useDispatch();
  const { user } = useSelector(store => store);

  useEffect(() => {
    getAgent(user.username).then((res) => {
      dispatch({ type: 'UPDATE_USER', payload: res.data });
    });
  }, []);

  return (
    <main>
      <Profile user={user} />
      <ThreeWayCallDetailsModal user={user} />
    </main>
  );
}

export default ProfilePage;
